import { render } from "./TypographyDrop.vue?vue&type=template&id=7f9394e0"
import script from "./TypographyDrop.vue?vue&type=script&lang=js"
export * from "./TypographyDrop.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__